// extracted by mini-css-extract-plugin
export default {"cards":"projects_cards__1n66E","card":"projects_card__-6tYL","cardborder":"projects_cardborder__au7mw","cardcontent":"projects_cardcontent__qfbC3"};